export const AUTH_COLORS = Object.freeze({
  brandGradient: 'linear-gradient(155deg, #09090b 0%, #171719 55%, #2b190b 100%)',
  accent: '#fc8019',
  accentStrong: '#d85d08',
  accentFocus: 'rgba(252, 128, 25, 0.18)',
  accentShadow: 'rgba(252, 128, 25, 0.28)',
  accentShadowHover: 'rgba(252, 128, 25, 0.4)',
  cta: '#fc8019',
  ctaStrong: '#e5660d',
  ctaShadow: 'rgba(216, 93, 8, 0.28)',
  ctaShadowHover: 'rgba(216, 93, 8, 0.38)',
  ctaBorder: 'rgba(255, 176, 0, 0.35)',
  ctaHighlight: 'rgba(255, 255, 255, 0.22)',
  ctaGlow: 'rgba(255, 176, 0, 0.18)',
  panelLine: 'rgba(17, 17, 17, 0.12)',
  panelLineStrong: 'rgba(17, 17, 17, 0.22)',
  panelAccentSoft: 'rgba(252, 128, 25, 0.12)',
  panelAccentStrong: '#fc8019',
  signalGreen: '#2c8f6b',
  inputTechBackground: '#faf8f5',
  inputTechBorder: '#ddd5ca',
  textHeading: '#171719',
  textBody: '#68635d',
  textLabel: '#332d27',
  textMuted: '#8c857d',
  textStrong: '#111827',
  inputBorder: '#ddd6ce',
  inputBackground: '#fcfaf7',
  panelBackground: '#ffffff',
  panelBackgroundAlt: 'linear-gradient(180deg, #fff 0%, #f8f3ed 100%)',
  overlayStrong: 'rgba(255, 255, 255, 0.78)',
  overlaySoft: 'rgba(227, 244, 246, 0.7)',
  featureGlass: 'rgba(252, 128, 25, 0.14)',
  featureBorder: 'rgba(255, 176, 0, 0.24)',
  formSurface: 'rgba(255,255,255,0.88)',
  formBorder: '#e7ded4',
  formShadow: 'rgba(10, 10, 10, 0.16)',
  panelGlow: 'rgba(252, 128, 25, 0.16)',
  panelGlowSoft: 'rgba(0, 0, 0, 0.06)',
  eyebrowBackground: 'rgba(252, 128, 25, 0.08)',
  eyebrowText: '#9a4309',
  eyebrowBorder: 'rgba(252, 128, 25, 0.2)',
  eyebrowShadow: 'rgba(130, 63, 12, 0.08)',
  hairlineGradient: 'linear-gradient(90deg, #171719 0%, #fc8019 58%, #ffb000 100%)',
  gridLine: 'rgba(17, 17, 17, 0.045)',
  inputInset: 'rgba(255, 255, 255, 0.85)',
  errorBackground: '#fef2f2',
  errorBorder: '#fecaca',
  errorText: '#b91c1c',
  successBackground: '#f0fdf4',
  successBorder: '#bbf7d0',
  successText: '#15803d',
  infoBackground: 'linear-gradient(180deg, #f4f8fc 0%, #eaf2f8 100%)',
  infoBorder: '#cfdeea',
  infoText: '#31506a',
});
